import {
  CLEAR_INTERVAL_ID,
  REMOVE_JOB,
  SCHEDULE_JOB,
  SET_INTERVAL_ID,
} from "../constants/reduxConstants";

export const scheduleJobAction = (payload) => {
  return {
    type: SCHEDULE_JOB,
    payload,
  };
};
export const removeJobAction = (payload) => {
  return {
    type: REMOVE_JOB,
    payload,
  };
};

export const setIntervalId = (payload) => {
  return {
    type: SET_INTERVAL_ID,
    payload,
  };
};

export const clearIntervalId = (payload) => {
  return {
    type: CLEAR_INTERVAL_ID,
    payload,
  };
};
